import React, { useContext, useEffect, useState } from "react";
import RegistrationContext from "../../contexts/RegistrationContext";
import { SquareArrowOutUpRight, TriangleAlert } from "lucide-react";
import axios from "axios";
import { base_url } from "../../config";

const tutorialDates = [
  {
    date: "15",
    month: "Aug",
    day: "Sat",
    year: "2026",
    location: "Bremen",
    tutday: 1

  },
  {
    date: "16",
    month: "Aug",
    day: "Sun",
    year: "2026",
    location: "Bremen",
    tutday: 2
  },
  {
    date: "17",
    month: "Aug",
    day: "Mon",
    year: "2026",
    location: "Bremen",
    tutday: 3
  },
];



const wscode = (id: number): string => id < 10 ? `T0${id}` : `T${id}`;

function ToggleSwitch({ enabled = false, changed }: { enabled?: boolean, changed?: (enabled: boolean) => void }) {
  const [switchEnabled, setswitchEnabled] = useState(enabled);

  return (
    <button
      onClick={() => {
        setswitchEnabled(!switchEnabled);
        if (changed) changed(!switchEnabled);
      }}
      className={`w-8 h-4 flex items-center rounded-full p-0.5 transition-colors duration-300 ${switchEnabled ? "bg-green-500" : "bg-gray-300"
        }`}
    >
      <div
        className={`bg-white w-3 h-3 rounded-full shadow-md transform transition-transform duration-300 ${switchEnabled ? "translate-x-4" : "translate-x-0"
          }`}
      />
    </button>
  );
}
function arraysEqual(a: number[], b: number[]) {
  if (a.length !== b.length) return false;
  const sortedA = [...a].sort();
  const sortedB = [...b].sort();
  return sortedA.every((val, idx) => val === sortedB[idx]);
}


export const TutorialSelection = () => {
  const { data, setData } = useContext(RegistrationContext);
  const tutlist = data.tutorials.map((tutorial: any) => {
    const days = [];
    if (tutorial.day1_morning_1st || tutorial.day1_morning_2nd || tutorial.day1_afternoon_1st || tutorial.day1_afternoon_2nd ) days.push(1);
    if (tutorial.day2_morning_1st || tutorial.day2_morning_2nd || tutorial.day2_afternoon_1st || tutorial.day2_afternoon_2nd ) days.push(2);
    if (tutorial.day3_morning_1st || tutorial.day3_morning_2nd || tutorial.day3_afternoon_1st || tutorial.day3_afternoon_2nd ) days.push(3);
    

    return {
      ...tutorial
      , days: days
    }
  })

  const tutDates = tutorialDates.map((date) => {
    var registered = false;
    if (data.tutorial_day1 && date.tutday === 1) registered = true;
    if (data.tutorial_day2 && date.tutday === 2) registered = true;
    if (data.tutorial_day3 && date.tutday === 3) registered = true;
    
    return {
      ...date,
      registered
    };
  });
  const [selectedTutorials, setSelectedTutorials] = useState(data.selected_tut);
  const [selectionChanged, setSelectionChanged] = useState(false);
  const [preferencesSaved, setPreferencesSaved] = useState(false);
  const initialSelection = data.selected_tut;


  const handleSubmit = async () => {

    try {
      const ans = await axios.post(`${base_url}/api/tutorial_update`, {
        selectedTutorials
      });
      setData(ans.data.data);
      setPreferencesSaved(true);
    } catch (error) {

    }
  };

  useEffect(() => {
    setSelectionChanged(!arraysEqual(selectedTutorials, initialSelection))
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedTutorials])


  if (preferencesSaved) {
    return (
      <div className="rounded-lg border bg-white p-6 shadow-sm" >
        <h2 className="mb-4 text-xl font-bold">Tutorial selection saved</h2>
        <p className="text-gray-700">
          Your Tutorial selection has been successfully saved.
        </p>

        <button
          className="mt-6 w-full bg-blue-600 hover:bg-blue-700 text-white font-semibold py-2 px-4 rounded-lg transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
          onClick={() => setPreferencesSaved(false)}
        >
          OK
        </button>
      </div>
    );
  }

  return (
    <div
      className=" rounded-lg border bg-white p-6 shadow-sm overflow-y-scroll"
      id="cancellation"

    >

      <h2 className="mb-4 text-xl font-bold">Tutorials</h2>
      
      {tutDates.map((tutorial_date: any, index: any) => {
        var fontcolor = tutorial_date.registered ? "text-black" : "text-gray-400 opacity-70"
        return (
          <div key={index} className="mb-4">
            <h3 className={`text-lg font-semibold ${fontcolor}`} >{tutorial_date.date} {tutorial_date.month} {tutorial_date.day}, {tutorial_date.year} - {tutorial_date.location} {!tutorial_date.registered && <span className="text-gray-600 text-sm"> — Not included in your registration</span>} </h3>

            {tutlist
              .filter((tutorial: any) => tutorial.days.includes(tutorial_date.tutday))
              .map((tutorial: any, index: any) => {
                const selected = selectedTutorials.includes(tutorial.id);
                return (
                  <div key={index} className={`flex gap-3 text-xs ${fontcolor} my-1 hover:bg-gray-50`}>
                    <div className="font-mono">{
                      wscode(tutorial.id)}
                    </div>
                    <div style={{width:"15px"}}>
                    {tutorial.url ? (<a href={tutorial.url} target="_blank" rel="noreferrer"><SquareArrowOutUpRight size={12} /></a>):" "}
                    </div>
                    
                    <div className="grow max-w-[800px]">
                      {tutorial.title}
                    </div>
                    <div style={{ width: "100px" }} className="flex items-center justify-end">
                      {selected && !tutorial_date.registered && (
                        <div className="relative group text-red-500 rounded-xl inline-block">
                          <TriangleAlert size={14} />

                        </div>
                      )}
                      {tutorial_date.registered && (
                        <div className="relative group text-red-500 rounded-xl inline-block">
                          <ToggleSwitch enabled={selected} changed={(n) => {
                            if (n) {
                              setSelectedTutorials([...selectedTutorials, tutorial.id]);
                            } else {
                              setSelectedTutorials(selectedTutorials.filter((id: Number) => id !== tutorial.id));
                            }

                          }} />
                        </div>
                      )}
                    </div>

                  </div>)
              })
            }
          </div>
        );
      }
      )}
      <div className="pt-6">
        <button
          disabled={!selectionChanged}
          type="submit"
          className="w-full bg-blue-600 hover:bg-blue-700 text-white font-medium py-3 px-4 rounded-lg transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 disabled:opacity-30"
          onClick={() => handleSubmit()}
        >
          Save New Tutorial Selection
        </button>
      </div>
    </div>

  );
};
